<div class="help-dialog">
  <div class="help-dialog-header d-flex align-items-center justify-content-between">
    <div class="help-title">What this service does</div>
    <button type="button" class="btn btn-link p-0 text-decoration-none" (click)="close()" aria-label="Close">
      <span class="material-icons">close</span>
    </button>
  </div>

  <div class="help-dialog-body">
    <div class="text-muted">
      <div class="mb-2">
        GeoAstra provides an <strong>NTRIP Caster</strong> service only. It is not a full <strong>CORS</strong> service on its own—please don’t confuse the two.
      </div>
      <div class="mb-3">
        A CORS service requires both RTK base station and NTRIP Caster service. (<strong>RTK Base</strong> + <strong>NTRIP Caster</strong> = <strong>CORS</strong>)
      </div>
      <div>
        To turn GeoAstra into a CORS service, simply connect your RTK base station to a GeoAstra NTRIP Caster mountpoint.
      </div>
    </div>
  </div>
</div>


